import { lazy, Suspense } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@ah/ui';
import { DiProvider } from './providers/DiProvider';
import { AppI18nProvider } from './providers/AppI18nProvider';
import { RequireAuth } from './RequireAuth';
import DashboardPage from '../pages/DashboardPage';

const CallPage = lazy(() => import('../features/voice/CallPage'));
const LoginPage = lazy(() => import('../features/auth/LoginPage'));
const RegisterPage = lazy(() => import('../features/auth/RegisterPage'));
const PayoutsPage = lazy(() => import('../pages/PayoutsPage'));
const SettingsPage = lazy(() => import('../pages/SettingsPage'));
const ProfilePage = lazy(() => import('../pages/ProfilePage'));

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 2, refetchOnWindowFocus: false } },
});

function Loading() {
  return (
    <div role="status" style={{ padding: 24, textAlign: 'center' }}>
      Loading…
    </div>
  );
}

export function App() {
  return (
    <DiProvider>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <AppI18nProvider>
            <BrowserRouter>
              <Suspense fallback={<Loading />}>
                <Routes>
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                  <Route path="/" element={<RequireAuth><DashboardPage /></RequireAuth>} />
                  <Route path="/profile" element={<RequireAuth><ProfilePage /></RequireAuth>} />
                  <Route path="/payouts" element={<RequireAuth><PayoutsPage /></RequireAuth>} />
                  <Route path="/settings" element={<RequireAuth><SettingsPage /></RequireAuth>} />
                  {/* Stripe Account Link return_url/refresh_url (STRIPE_CONNECT_RETURN_URL / STRIPE_CONNECT_REFRESH_URL,
                      docs/stripe-dashboard-setup.md §4) — both just land back on PayoutsPage, which already
                      re-checks onboarding status on load regardless of which one Stripe used. */}
                  <Route path="/payouts/return" element={<RequireAuth><PayoutsPage /></RequireAuth>} />
                  <Route path="/payouts/refresh" element={<RequireAuth><PayoutsPage /></RequireAuth>} />
                  <Route path="/call/:bookingId" element={<RequireAuth><CallPage /></RequireAuth>} />
                </Routes>
              </Suspense>
            </BrowserRouter>
          </AppI18nProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </DiProvider>
  );
}
